import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const REVIEWS = [
  { id: "t1", name: "Sarah M.", area: "Local homeowner", text: "Roddy turned our jungle of a backyard into something we're actually proud of. Reliable, friendly and great value." },
  { id: "t2", name: "Dave T.", area: "Weekly mowing client", text: "Lawn's never looked better. He shows up when he says he will and it's a tidy, even cut every single time." },
  { id: "t3", name: "Priya K.", area: "Garden clean-up", text: "Got an instant quote, booked it in, and the garden was transformed the same week. Couldn't recommend more." },
  { id: "t4", name: "Mark & Jen", area: "Regular clients", text: "Handled the whole yard without fuss — mowing, edging, the lot. Top bloke and top work." },
];
const STARS = [1, 2, 3, 4, 5];

const reveal = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-40px" },
};
const WHITE_BG = { backgroundColor: "#fff" };

export const Testimonials = () => {
  return (
    <section id="reviews" className="py-20 lg:py-28 bg-sand scroll-mt-20">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-2xl mb-12">
          <p className="text-xs tracking-[0.2em] uppercase text-lawn font-bold mb-3">Reviews</p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-ink">
            What the neighbours are saying
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 gap-5">
          {REVIEWS.map((r, i) => (
            <motion.blockquote
              key={r.id}
              data-testid={`review-${i}`}
              {...reveal}
              transition={{ duration: 0.5, delay: (i % 2) * 0.1 }}
              className="bg-surface border border-line rounded-2xl p-7"
              style={WHITE_BG}
            >
              <Quote className="w-8 h-8 text-lawn/40 mb-3" />
              <div className="flex mb-3">
                {STARS.map((n) => (
                  <Star key={`${r.id}-star-${n}`} className="w-4 h-4 fill-lawn text-lawn" />
                ))}
              </div>
              <p className="text-ink text-lg leading-relaxed">"{r.text}"</p>
              <footer className="mt-5">
                <p className="font-heading font-bold text-ink">{r.name}</p>
                <p className="text-sm text-ink-soft">{r.area}</p>
              </footer>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
};
